import {AppBarPage} from "../../components/AppBarPage";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import * as React from "react";
import {
    Button,
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    ListItemText,
    Paper,
    Select,
    SelectChangeEvent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import {useEffect, useLayoutEffect, useState} from "react";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {GroupedViewsCountPerDayDTO} from "../../models/GroupedViewsCountPerDayDTO";
import {AnalyticsService} from "../../services/AnalyticsService";
import dayjs from "dayjs";
import {DateTimeUtils} from "../../utils/DateTimeUtils";
import {ViewsCount} from "../../models/ViewsCount";
import {ClientDTO} from "../../models/ClientDTO";
import {ClientService} from "../../services/ClientService";
import {ClientArtistService} from "../../services/ClientArtistService";
import {PaginatedSelect} from "../../components/PaginatedSelect";
import {ClientArtistDTO} from "../../models/ClientArtistDTO";
import {Page} from "../../pagination/Page";
import {ServicesService} from "../../services/ServicesService";
import {ServiceDTO} from "../../models/ServiceDTO";
import {CountryDTO} from "../../models/CountryDTO";
import {CountryService} from "../../services/CountryService";
import IconButton from "@mui/material/IconButton";
import {Clear} from "@mui/icons-material";
import {strings} from "../../localization/Localization";
import Box from "@mui/material/Box";
import "../../App.css"
import {ChartComponent} from "../../components/ChartComponent";
import {CollectionUtils} from "../../utils/CollectionUtils";
import {FullPageLoadingCircle} from "../../components/FullPageLoadingCircle";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {useNavigate} from "react-router-dom";
import {Routes} from "../../router/Routes";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {PaginatedMultiSelect} from "../../components/PaginatedMultiSelect";
import {ScrapedDataService} from "../../services/ScrapedDataService";
import { ViewsCountPerDayDTO } from "../../models/ViewsCountPerDayDTO";
import {ViewsCountPerDayAndArtistDTO} from "../../models/ViewsCountPerDayAndArtistDTO";
import { PaginationPlus } from "../../components/PaginationPlus";
import {defaultRowsPerPageOptions} from "../../common/Constants";
import {StorageService} from "../../storage/StorageService";
import {BotViewsByPlatformPerDayDTO} from "../../models/BotViewsByPlatformPerDayDTO";
import {GroupedViewsByPlatformDTO} from "../../models/GroupedViewsByPlatformDTO";

class DataItem {
    constructor(
        public key: string,
        public label: string,
        public botStat: number,
        public scrapedStat: number,
        public mobileUniqueListeners: number,
        public mobileViews: number,
        public browserViews: number,
    ) {};
}

interface SortConfig {
    key: keyof DataItem | null;
    direction: 'ascending' | 'descending' | null;
}

const transferToInputDateFormat = (date: Date) => {
    return date.toISOString().split("T")[0];
}

const getDateXDaysAgoValue = (days: number) => {
    return (new Date).getTime() - (days * 24 * 60 * 60 * 1000)
}

export function DashboardPage() {
    const SERVICE = "service";
    const COUNTRY = "country";
    const ARTIST = "artist";

    const TODAY = 0;
    const YESTERDAY = 1;
    const LAST_7_DAYS = 7;
    const LAST_14_DAYS = 14;
    const LAST_30_DAYS = 30;
    const LAST_90_DAYS = 90;
    const LAST_12_MONTHS = 365;
    const DATE_RANGE = -1;

    const OTHERS = "Others";
    const [sortConfig, setSortConfig] = useState<SortConfig>({ key: null, direction: null });

    const id = StorageService.getJWTPayload()?.clientId;
    const [clicked, setClicked] = useState<boolean>(false);
    const [groupBy, setGroupBy] = useState<string>(SERVICE);
    const [viewsPerDayGrouped, setViewsPerDayGrouped] = useState<GroupedViewsCountPerDayDTO[]>([]); //bot Views
    const [scrapedViewsPerDayGrouped, setScrapedViewsPerDayGrouped] = useState<GroupedViewsCountPerDayDTO[]>([]); //bot Views
    const [streamsFilter, setStreamsFilter] = useState<number>(ViewsCount.STAT_STREAMS);
    const [periodFilter, setPeriodFilter] = useState<number>(DATE_RANGE);
    const [dateFrom, setDateFrom] = useState<string>(transferToInputDateFormat(new Date(getDateXDaysAgoValue(LAST_7_DAYS))));
    const [dateTo, setDateTo] = useState<string>(transferToInputDateFormat(new Date()));
    const [client, setClient] = useState<ClientDTO | undefined>(undefined);
    const [serviceIdFilter, setServiceIdFilter] = useState<number | undefined>(undefined);
    const [countryIdFilter, setCountryIdFilter] = useState<CountryDTO | undefined>(undefined);
    const [artistFilter, setArtistFilter] = useState<ClientArtistDTO[]>([]);
    const [services, setServices] = useState<ServiceDTO[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filterValues, setFilterValues] = useState<string[]>([]); // Selected filter values
    const [oursSelected, setOursSelected] = useState<boolean>(false);
    const [notOursSelected, setNotOursSelected] = useState<boolean>(false);
    const [oursArtists, setOursArtists] = useState<ClientArtistDTO[]>([]);
    const [open, setOpen] = useState(false);
    const [tempFilterValues, setTempFilterValues] = useState<string[]>([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [scrapedDataTotalPerDay, setScrapedDataTotalPerDay] = useState<ViewsCountPerDayDTO[]>([]);
    const [scrapedDataAllForChart, setScrapedDataAllForChart] = useState<ViewsCountPerDayAndArtistDTO[]>([]);
    const [scrapedDataPaged, setScrapedDataPaged] = useState<ViewsCountPerDayAndArtistDTO[]>([]);
    const [platformData, setPlatformData] = useState<BotViewsByPlatformPerDayDTO[]>([]);
    const [platformByGroup, setPlatformByGroup] = useState<GroupedViewsByPlatformDTO[]>([]);
    const [scrapedTotalElements, setScrapedTotalElements] = useState(0);
    const [scrapedPage, setScrapedPage] = useState(0);
    const [scrapedRowsPerPage, setScrapedRowsPerPage] = useState(10);
    const [scrapedSort, setScrapedSort] = useState("");
    const [comparisonPage, setComparisonPage] = useState(0);
    const [comparisonRowsPerPage, setComparisonRowsPerPage] = useState(10);
    const [comparisonSort, setComparisonSort] = useState<{key: 'label' | 'botStat' | 'scrapedStat' | 'diff' | null, direction: 'asc' | 'desc' | null}>({ key: null, direction: null });

    const navigate = useNavigate();

    const handleSummaryReportClick = () => {
        navigate(Routes.SUMMARY_REPORT);
    };

    const handleImportedSongsClick = () => {
        navigate(Routes.IMPORTED_SONGS);
    };

    const handleScrapedDataClick = () => {
        navigate(Routes.SCRAPED_DATA);
    };

    const handleFilterValueChange = (event: SelectChangeEvent<typeof tempFilterValues>) => {
        setTempFilterValues(event.target.value as string[]);
    };

    const handleFilterClose = () => {
        setFilterValues(tempFilterValues);
        setOpen(false);
    };

    const handleFilterOpen = () => {
        setOpen(true);
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const requestSort = (key: keyof DataItem) => {
        let direction: 'ascending' | 'descending' = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (columnKey: keyof DataItem) => {
        if (sortConfig.key === columnKey) {
            return sortConfig.direction === 'ascending' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />;
        }
        return null;
    };

    function mapViewsCount(items: GroupedViewsCountPerDayDTO[]): Map<string, GroupedViewsCountPerDayDTO> {
        const map = new Map<string, GroupedViewsCountPerDayDTO>();

        for (const item of items) {
            map.set(item.key, item);
        }

        return map;
    }

    const viewsCountPerDayMap = mapViewsCount(viewsPerDayGrouped);
    const scrapedViewsPerDayMap = mapViewsCount(scrapedViewsPerDayGrouped);

    const platformByGroupMap = new Map<string, GroupedViewsByPlatformDTO>();
    platformByGroup.forEach(p => platformByGroupMap.set(p.groupKey, p));

    function handleClickedChange() {
        if(clicked){
            setClicked(false)
        } else {
            setClicked(true)
        }
    }

    const viewersOptionDropdown = [
        {
            label: "Streams",
            id: ViewsCount.STAT_STREAMS,
        },
        {
            label: "Unique listens",
            id: ViewsCount.STAT_UNIQUE_LISTENERS,
        },
        {
            label: "Accounts",
            id: ViewsCount.STAT_ACCOUNTS,
        },
        {
            label: "Songs",
            id: ViewsCount.STAT_SONGS,
        }
    ]

    const typeOfFilterOptionDropdown = [
        {
            label: "Service",
            id: SERVICE
        },
        {
            label: "Country",
            id: COUNTRY
        },
        {
            label: "Artist",
            id: ARTIST
        }
    ]

    const periodFilterOptionDropdown = [
        {
            label: "Today",
            id: TODAY
        },
        {
            label: "Yesterday",
            id: YESTERDAY
        },
        {
            label: "Last 7 days",
            id: LAST_7_DAYS
        },
        {
            label: "Last 14 days",
            id: LAST_14_DAYS
        },
        {
            label: "Last 30 days",
            id: LAST_30_DAYS
        },
        {
            label: "Last 90 days",
            id: LAST_90_DAYS
        },
        {
            label: "Last 12 months",
            id: LAST_12_MONTHS
        },
        {
            label: "Date range",
            id: DATE_RANGE
        }
    ]
    const handleStreamsFilter = (event: SelectChangeEvent) => {
        setStreamsFilter(+event.target.value);
    }

    const handleServiceFilter = (event: SelectChangeEvent) => {
        setServiceIdFilter(+event.target.value);
    }

    const handleCountryFilter = (event: CountryDTO | undefined) => {
        setCountryIdFilter(event);
    }

    const handleArtistFilter = (artists: ClientArtistDTO[]) => {
        setArtistFilter(artists);
    }

    const handleTypeFilter = (event: SelectChangeEvent) => {
        setGroupBy(event.target.value);
        setFilterValues([]);
    }

    const handlePeriodFilter = (event: SelectChangeEvent) => {
        let value = +event.target.value;

        if (value !== -1) {
            let dateT = new Date();
            let dateF = new Date(getDateXDaysAgoValue(LAST_7_DAYS));

            setDateFrom(transferToInputDateFormat(dateF));
            setDateTo(transferToInputDateFormat(dateT));
        }

        setPeriodFilter(value);
    }

    useEffect(() => {
        if (id) {
            ClientService.findById(id).then(client => {
                setClient(client);
            })
        }

        async function getAllServices() {
            const services = await ServicesService.getAllServices();
            setServices(services);
        }

        getAllServices()
    }, []);

    function getDateFrom(){
        const date = new Date();
        date.setDate(date.getDate() - periodFilter);
        return date;
    }

    function getDateTo(){
        const date = new Date();
        if(periodFilter === TODAY)
        date.setDate(date.getDate() + 1);
        return date;
    }

    const handleDateFromChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedDateFrom = event.target.value;
        const selectedDateTo = dayjs(dateTo);

        if (dayjs(selectedDateFrom).isAfter(selectedDateTo)) {
            alert('Date from cannot be later than date to');
        } else {
            const maxDateFrom = selectedDateTo.subtract(3, 'month');

            if (dayjs(selectedDateFrom).isBefore(maxDateFrom)) {
                alert('Date from cannot be more than 3 months from date to');
            } else {
                setDateFrom(selectedDateFrom);
            }
        }
    };

    const handleDateToChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedDateTo = event.target.value;
        const selectedDateFrom = dayjs(dateFrom);

        if (dayjs(selectedDateTo).isBefore(selectedDateFrom)) {
            alert('Date to cannot be earlier than date from');
        } else {
            const maxDateTo = selectedDateFrom.add(3, 'month');

            if (dayjs(selectedDateTo).isAfter(maxDateTo)) {
                alert('Date to cannot be more than 3 months from date from');
            } else {
                setDateTo(selectedDateTo);
            }
        }
    };

    const countryFilterVisible = streamsFilter !== ViewsCount.STAT_SONGS || groupBy === COUNTRY;

    useEffect(() => {
        async function getListenedArtistsViewsCountPerDayGrouped() {
            setIsLoading(true)
            if (periodFilter !== -1) {
                const response = await AnalyticsService.getListenedArtistsViewsCountPerDayGrouped(id, DateTimeUtils.formatDateDayJs(dayjs(getDateFrom())), DateTimeUtils.formatDateDayJs(dayjs(getDateTo())), groupBy, countryFilterVisible ? countryIdFilter?.countryCode2 : undefined, serviceIdFilter, artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined)
                setViewsPerDayGrouped(response.botViews);
                setScrapedViewsPerDayGrouped(response.scrapedViews);
                response.botViews.map((e) => setGroupBy(e.groupBy))
            } else if (periodFilter === -1 && dateFrom !== "" && dateTo !== "") {
                const response = await AnalyticsService.getListenedArtistsViewsCountPerDayGrouped(id, DateTimeUtils.formatDateDayJs(dayjs(dateFrom)), DateTimeUtils.formatDateDayJs(dayjs(dateTo)), groupBy, countryFilterVisible ? countryIdFilter?.countryCode2 : undefined, serviceIdFilter, artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined)
                setViewsPerDayGrouped(response.botViews);
                setScrapedViewsPerDayGrouped(response.scrapedViews);
                response.botViews.map((e) => setGroupBy(e.groupBy))
            }
            // response.map((s) => setServiceIdFilter(s.serviceId))
            setIsLoading(false)
        }

        getListenedArtistsViewsCountPerDayGrouped();
    }, [periodFilter, groupBy, serviceIdFilter, countryIdFilter, artistFilter, dateFrom, dateTo])

    useEffect(() => {
        async function fetchBotViewsByPlatform() {
            let fromDate: string | null | undefined;
            let toDate: string | null | undefined;

            if (periodFilter !== -1) {
                fromDate = DateTimeUtils.formatDateDayJs(dayjs(getDateFrom()));
                toDate = DateTimeUtils.formatDateDayJs(dayjs(getDateTo()));
            } else if (dateFrom !== "" && dateTo !== "") {
                fromDate = DateTimeUtils.formatDateDayJs(dayjs(dateFrom));
                toDate = DateTimeUtils.formatDateDayJs(dayjs(dateTo));
            } else {
                return;
            }

            const result = await AnalyticsService.getListenedArtistsViewsCountPerDayByPlatform(
                id,
                fromDate,
                toDate,
                countryIdFilter?.countryCode2,
                serviceIdFilter,
                artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined
            );
            setPlatformData(result);
        }

        fetchBotViewsByPlatform();
    }, [periodFilter, serviceIdFilter, countryIdFilter, artistFilter, dateFrom, dateTo])

    useEffect(() => {
        async function fetchBotViewsByPlatformGrouped() {
            let fromDate: string | null | undefined;
            let toDate: string | null | undefined;

            if (periodFilter !== -1) {
                fromDate = DateTimeUtils.formatDateDayJs(dayjs(getDateFrom()));
                toDate = DateTimeUtils.formatDateDayJs(dayjs(getDateTo()));
            } else if (dateFrom !== "" && dateTo !== "") {
                fromDate = DateTimeUtils.formatDateDayJs(dayjs(dateFrom));
                toDate = DateTimeUtils.formatDateDayJs(dayjs(dateTo));
            } else {
                return;
            }

            const result = await AnalyticsService.getListenedArtistsViewsCountByPlatformGrouped(
                id,
                fromDate,
                toDate,
                groupBy,
                countryIdFilter?.countryCode2,
                serviceIdFilter,
                artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined
            );
            setPlatformByGroup(result);
        }

        fetchBotViewsByPlatformGrouped();
    }, [periodFilter, groupBy, serviceIdFilter, countryIdFilter, artistFilter, dateFrom, dateTo])

    function getStatistic(viewsCount: ViewsCount) {
        if (streamsFilter === ViewsCount.STAT_STREAMS) {
            return viewsCount.viewCount;
        } else if (streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS) {
            return viewsCount.uniqueListeners;
        } else if (streamsFilter === ViewsCount.STAT_ACCOUNTS) {
            return viewsCount.accounts;
        } else if (streamsFilter === ViewsCount.STAT_SONGS) {
            return viewsCount.songs;
        }

        return 0;
    }

    function getDataItems(): DataItem[] {
        const keys = [
            ... new Set<string>([
                ...viewsPerDayGrouped.map(item => item.key),
                ...scrapedViewsPerDayGrouped.map(item => item.key)
            ])
        ];

        keys.sort();

        if (groupBy === ARTIST) {
            CollectionUtils.shiftToEnd(keys, item => item === OTHERS);
        }

        const dataItems: DataItem[] = [];

        for (const key of keys) {
            const botItem = viewsCountPerDayMap.has(key) ? viewsCountPerDayMap.get(key) : undefined;
            const scrapedItem = scrapedViewsPerDayMap.has(key) ? scrapedViewsPerDayMap.get(key) : undefined;

            if (botItem !== undefined || scrapedItem !== undefined) {
                dataItems.push(new DataItem(
                    key,
                    botItem?.label ?? scrapedItem?.label ?? "",
                    botItem?.total?.getStat(streamsFilter) ?? 0,
                    scrapedItem?.total?.getStat(streamsFilter) ?? 0,
                    botItem?.total?.mobileUniqueListeners ?? 0,
                    platformByGroupMap.get(key)?.mobileViews ?? 0,
                    platformByGroupMap.get(key)?.browserViews ?? 0,
                ))
            }
        }

        return dataItems;
    }

    function getScrapedDataByArtist(): Map<string, number> {
        const artistTotals = new Map<string, number>();

        scrapedDataAllForChart.forEach(item => {
            const currentTotal = artistTotals.get(item.artist) || 0;
            const valueToAdd = streamsFilter === ViewsCount.STAT_STREAMS
                ? item.viewCount
                : item.uniqueListeners;
            artistTotals.set(item.artist, currentTotal + valueToAdd);
        });

        return artistTotals;
    }


    const dataItems = getDataItems();

    // const seriesScraped = scrapedViewsPerDayGrouped?.map((series) => {
    //     return {
    //         name: series.label,
    //         data: series.viewsCountPerDay.map((views) => getStatistic(views))
    //     }
    // })

    function getChartCategories() {
        if (viewsPerDayGrouped.length === 0) {
            return [];
        }

        return viewsPerDayGrouped[0]?.viewsCountPerDay.map((item) => item.date);
    }

    // function getScrapedChartCategories() {
    //     if (scrapedViewsPerDayGrouped.length === 0) {
    //         return [];
    //     }
    //
    //     return scrapedViewsPerDayGrouped[0]?.viewsCountPerDay.map((item) => item.date);
    // }

    const tickAmountChange = (tickAmount: number) => {
        if (periodFilter === TODAY) {
            tickAmount = 1;
        } else if (periodFilter === YESTERDAY) {
            tickAmount = 1
        } else if (periodFilter === LAST_7_DAYS) {
            tickAmount = 6;
        } else if (periodFilter === LAST_14_DAYS) {
            tickAmount = 13;
        } else if (periodFilter === LAST_30_DAYS || periodFilter === LAST_90_DAYS || periodFilter === LAST_12_MONTHS || periodFilter === DATE_RANGE) {
            tickAmount = 29
        }

        return tickAmount;
    }

    const sortedDataItems = [...dataItems].sort((a, b) => {
        if (!sortConfig.key) {
            return 0; // No sort config, so no sorting applied
        }
        if (typeof a[sortConfig.key] === 'number' && typeof b[sortConfig.key] === 'number') {
            // Both values are numbers, so we can compare them directly
            return sortConfig.direction === 'ascending'
                ? (a[sortConfig.key] as number) - (b[sortConfig.key] as number)
                : (b[sortConfig.key] as number) - (a[sortConfig.key] as number);
        }
        // If the values are not numbers, fall back to string comparison
        return sortConfig.direction === 'ascending'
            ? String(a[sortConfig.key]).localeCompare(String(b[sortConfig.key]))
            : String(b[sortConfig.key]).localeCompare(String(a[sortConfig.key]));
    });

    const filteredDataItems = filterValues.length > 0
        ? sortedDataItems.filter(item => filterValues.includes(item.key))
        : sortedDataItems; // Return all items if no filterValues are selected

    const series = groupBy === ARTIST && filterValues.length === 0 && artistFilter.length === 0 || oursSelected
        ? [{
            name: strings.total,
            data: viewsPerDayGrouped.length > 0
                ? viewsPerDayGrouped[0].viewsCountPerDay.map((_, index) => {
                    return viewsPerDayGrouped.reduce((sum, artist) => {
                        return sum + getStatistic(artist.viewsCountPerDay[index]);
                    }, 0);
                })
                : []
        }]
        : filteredDataItems.map((dataItem) => {
            const botItem = viewsCountPerDayMap.get(dataItem.key);
            return {
                name: dataItem.label,
                data: botItem ? botItem.viewsCountPerDay.map((views) => getStatistic(views)) : []
            };
        });

    useEffect(() => {
        async function fetchOursArtists() {
            if (id) {
                const ours = await ClientArtistService.findAllOurs(id);
                setOursArtists(ours);
            } else {
                setOursArtists([]);
            }
        }

        fetchOursArtists();
    }, []);

    useEffect(() => {
        if (groupBy !== ARTIST) {
            setScrapedDataTotalPerDay([]);
            setScrapedDataPaged([]);
            setScrapedDataAllForChart([]);
            setScrapedTotalElements(0);
            return;
        }

        async function fetchScrapedDataTotal() {
            setIsLoading(true);
            try {
                let fromDate: string;
                let toDate: string;

                if (periodFilter !== -1) {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(getDateFrom())) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(getDateTo())) || '';
                } else {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(dateFrom)) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(dateTo)) || '';
                }

                const scrapedDataTotal = await ScrapedDataService.getScrapedViewsCountPerDayWithMultipleArtistFilter(
                    id,
                    fromDate,
                    toDate,
                    artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined,
                    serviceIdFilter
                );
                setScrapedDataTotalPerDay(scrapedDataTotal);
            } finally {
                setIsLoading(false);
            }
        }

        fetchScrapedDataTotal();
    }, [groupBy, periodFilter, dateFrom, dateTo, artistFilter, serviceIdFilter]);

    useEffect(() => {
        if (groupBy !== ARTIST) return;

        async function fetchScrapedDataPaged() {
            setIsLoading(true);
            try {
                let fromDate: string;
                let toDate: string;

                if (periodFilter !== -1) {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(getDateFrom())) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(getDateTo())) || '';
                } else {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(dateFrom)) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(dateTo)) || '';
                }

                const result = await ScrapedDataService.getScrapedViewsAndTotalListenersCountPerArtistPaged(
                    id,
                    fromDate,
                    toDate,
                    scrapedPage,
                    scrapedRowsPerPage,
                    scrapedSort,
                    artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined,
                    serviceIdFilter
                );
                setScrapedDataPaged(result.content);
                setScrapedTotalElements(result.totalElements);
            } finally {
                setIsLoading(false);
            }
        }

        fetchScrapedDataPaged();
    }, [groupBy, periodFilter, dateFrom, dateTo, scrapedPage, scrapedRowsPerPage, scrapedSort, artistFilter, serviceIdFilter]);

    useEffect(() => {
        if (groupBy !== ARTIST) return;

        async function fetchScrapedDataForChart() {
            setIsLoading(true);
            try {
                let fromDate: string;
                let toDate: string;

                if (periodFilter !== -1) {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(getDateFrom())) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(getDateTo())) || '';
                } else {
                    fromDate = DateTimeUtils.formatDateDayJs(dayjs(dateFrom)) || '';
                    toDate = DateTimeUtils.formatDateDayJs(dayjs(dateTo)) || '';
                }

                const scrapedDataByArtist = await ScrapedDataService.getScrapedViewsCountPerDayAndArtistWithMultipleArtistFilter(
                    id,
                    fromDate,
                    toDate,
                    serviceIdFilter,
                    artistFilter.length > 0 ? artistFilter.map(a => a.artist) : undefined
                );
                setScrapedDataAllForChart(scrapedDataByArtist);
            } finally {
                setIsLoading(false);
            }
        }

        fetchScrapedDataForChart();
    }, [groupBy, periodFilter, dateFrom, dateTo, artistFilter, serviceIdFilter]);

    function aggregateScrapedDataByDay() {
        let startDate: dayjs.Dayjs;
        let endDate: dayjs.Dayjs;

        if (periodFilter !== -1) {
            startDate = dayjs(getDateFrom());
            endDate = dayjs(getDateTo());
        } else {
            startDate = dayjs(dateFrom);
            endDate = dayjs(dateTo);
        }

        if (artistFilter.length > 0 && scrapedDataAllForChart.length > 0) {
            const artistDataMap = new Map<string, Map<string, ViewsCountPerDayAndArtistDTO>>();

            scrapedDataAllForChart.forEach(item => {
                if (item.date && item.artist) {
                    if (!artistDataMap.has(item.artist)) {
                        artistDataMap.set(item.artist, new Map());
                    }
                    const dateString = item.date.split('T')[0];
                    artistDataMap.get(item.artist)!.set(dateString, item);
                }
            });

            return Array.from(artistDataMap.entries()).map(([artistName, dataMap]) => {
                const dataCounts: number[] = [];

                let current = startDate;
                while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
                    const dateString = current.format('YYYY-MM-DD');
                    const data = dataMap.get(dateString);

                    if (streamsFilter === ViewsCount.STAT_STREAMS) {
                        dataCounts.push(data?.viewCount ?? 0);
                    } else if (streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS) {
                        dataCounts.push(data?.uniqueListeners ?? 0);
                    }

                    current = current.add(1, 'day');
                }

                return {
                    name: artistName,
                    data: dataCounts
                };
            });
        } else {
            const dataMap = new Map<string, ViewsCountPerDayDTO>();
            scrapedDataTotalPerDay.forEach(item => {
                if (item.date) {
                    const dateString = item.date.split('T')[0];
                    dataMap.set(dateString, item);
                }
            });

            const dataCounts: number[] = [];

            let current = startDate;
            while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
                const dateString = current.format('YYYY-MM-DD');
                const data = dataMap.get(dateString);

                if (streamsFilter === ViewsCount.STAT_STREAMS) {
                    dataCounts.push(data?.viewCount ?? 0);
                } else if (streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS) {
                    dataCounts.push(data?.uniqueListeners ?? 0);
                }

                current = current.add(1, 'day');
            }

            const seriesName = streamsFilter === ViewsCount.STAT_STREAMS
                ? strings.streamsBot
                : strings.uniqueListenersActual;

            return [
                {
                    name: seriesName,
                    data: dataCounts
                }
            ];
        }
    }

    function getScrapedDateCategories() {
        let startDate: dayjs.Dayjs;
        let endDate: dayjs.Dayjs;

        if (periodFilter !== -1) {
            startDate = dayjs(getDateFrom());
            endDate = dayjs(getDateTo());
        } else {
            startDate = dayjs(dateFrom);
            endDate = dayjs(dateTo);
        }

        const categories: string[] = [];
        let current = startDate;

        while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
            categories.push(current.format('YYYY-MM-DD'));
            current = current.add(1, 'day');
        }

        return categories;
    }

    function aggregateBotPlatformDataByDay() {
        let startDate: dayjs.Dayjs;
        let endDate: dayjs.Dayjs;

        if (periodFilter !== -1) {
            startDate = dayjs(getDateFrom());
            endDate = dayjs(getDateTo());
        } else {
            startDate = dayjs(dateFrom);
            endDate = dayjs(dateTo);
        }

        const dataMap = new Map<string, { mobileViews: number; browserViews: number }>();

        platformData.forEach(item => {
            const dateString = item.date.split('T')[0];
            const existing = dataMap.get(dateString);
            if (existing) {
                existing.mobileViews += item.mobileViews;
                existing.browserViews += item.browserViews;
            } else {
                dataMap.set(dateString, {
                    mobileViews: item.mobileViews,
                    browserViews: item.browserViews
                });
            }
        });

        const mobileCounts: number[] = [];
        const browserCounts: number[] = [];

        let current = startDate;
        while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
            const dateString = current.format('YYYY-MM-DD');
            const data = dataMap.get(dateString);
            mobileCounts.push(data?.mobileViews ?? 0);
            browserCounts.push(data?.browserViews ?? 0);
            current = current.add(1, 'day');
        }

        return [
            { name: strings.mobileViews, data: mobileCounts },
            { name: strings.browserViews, data: browserCounts }
        ];
    }


    const isOursArtist = (artistLabel: string) => {
        return oursArtists.some(artist => artist.artist === artistLabel);
    };

    const handleOursCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setOursSelected(event.target.checked);

        if (event.target.checked) {
            setNotOursSelected(false);

            const oursKeys = sortedDataItems
                .filter(item => isOursArtist(item.label))
                .map(item => item.key);

            setFilterValues(oursKeys);
            setTempFilterValues(oursKeys);
        } else {
            setFilterValues([]);
        }
    };

    const handleNotOursCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setNotOursSelected(event.target.checked);

        if (event.target.checked) {
            setOursSelected(false);

            const notOursKeys = sortedDataItems
                .filter(item => !isOursArtist(item.label))
                .map(item => item.key);

            setFilterValues(notOursKeys);
            setTempFilterValues(notOursKeys);
        } else {
            setFilterValues([]);
        }
    };

    const handleRemoveSelectedOptions = () => {
        setFilterValues([]);
        setTempFilterValues([]);
        setOursSelected(false);
        setNotOursSelected(false);
    }

    const handleScrapedChangePage = (event: unknown, newPage: number) => {
        setScrapedPage(newPage);
    };

    const handleScrapedChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setScrapedRowsPerPage(parseInt(event.target.value, 10));
        setScrapedPage(0);
    };

    const handleScrapedSort = (field: string) => {
        let newSort = `${field},asc`;

        if (scrapedSort.startsWith(`${field},asc`)) {
            newSort = `${field},desc`;
        } else if (scrapedSort.startsWith(`${field},desc`)) {
            newSort = '';
        }

        setScrapedSort(newSort);
    };

    const getScrapedSortIcon = (field: string) => {
        if (scrapedSort.startsWith(`${field},asc`)) {
            return <ArrowUpwardIcon fontSize="small" />;
        } else if (scrapedSort.startsWith(`${field},desc`)) {
            return <ArrowDownwardIcon fontSize="small" />;
        }
        return null;
    };

    const totalBotStat = filteredDataItems.reduce((sum, item) => sum + item.botStat, 0);
    const totalMobileUniqueListeners = filteredDataItems.reduce((sum, item) => sum + item.mobileUniqueListeners, 0);
    const totalMobileStreams = filteredDataItems.reduce((sum, item) => sum + item.mobileViews, 0);
    const totalBrowserStreams = filteredDataItems.reduce((sum, item) => sum + item.browserViews, 0);

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    useLayoutEffect(() => {
        window.scrollTo(scrollX, scrollY);
    });

    let chartText = strings.streamsBot;

    if (streamsFilter === ViewsCount.STAT_ACCOUNTS) {
        chartText =  strings.accountsBot;
    } else if (streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS) {
        chartText = strings.uniqueListenersBot;
    } else if (streamsFilter === ViewsCount.STAT_SONGS) {
        chartText = strings.songsBot;
    }

    const handleComparisonChangePage = (event: unknown, newPage: number) => {
        setComparisonPage(newPage);
    };

    const handleComparisonChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setComparisonRowsPerPage(parseInt(event.target.value, 10));
        setComparisonPage(0);
    };

    const handleComparisonSort = (field: 'label' | 'botStat' | 'scrapedStat' | 'diff') => {
        let newDirection: 'asc' | 'desc' = 'asc';
        if (comparisonSort.key === field && comparisonSort.direction === 'asc') {
            newDirection = 'desc';
        }
        setComparisonSort({ key: field, direction: newDirection });
    };

    const getComparisonSortIcon = (field: string) => {
        if (comparisonSort.key === field) {
            return comparisonSort.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />;
        }
        return null;
    };

    const paginatedDataItems = groupBy === ARTIST
        ? filteredDataItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : filteredDataItems;

    return(
        <>
            <AppBarPage pageTitle={strings.analytics} component={
                <>
                    <FullPageLoadingCircle
                        loading={isLoading}
                    />
                  <AppBar position="absolute" sx={{marginTop: "65.5px", minHeight: "65.5px" }} color={"secondary"}>
                    <Toolbar>
                        <Button
                            onClick={handleSummaryReportClick}
                            sx={{
                                marginLeft: "20px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                color: "black",
                                backgroundColor: "#efefef",
                                width: "10%",
                                '&:hover': {
                                    backgroundColor: "lightgray",
                                },
                            }}
                        >
                            {strings.summaryReport}
                        </Button>
                        <Button
                            onClick={handleImportedSongsClick}
                            sx={{
                                marginLeft: "20px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                color: "black",
                                backgroundColor: "#efefef",
                                width: "10%",
                                '&:hover': {
                                    backgroundColor: "lightgray",
                                },
                            }}
                        >
                            {strings.importedSongs}
                        </Button>
                        <Button
                            onClick={handleScrapedDataClick}
                            sx={{
                                marginLeft: "20px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                color: "black",
                                backgroundColor: "#efefef",
                                width: "10%",
                                '&:hover': {
                                    backgroundColor: "lightgray",
                                },
                            }}
                        >
                            {strings.scrapedData}
                        </Button>
                        <Button onClick={handleClickedChange} color={"success"} variant={"contained"}
                                sx={{marginLeft: "auto", borderRadius: "50px"}} size={"large"}>
                            <TuneIcon sx={{paddingRight: "5px"}}
                                      fontSize={"medium"}/>{clicked ? strings.hideFilters : strings.filterBy}</Button>
                    </Toolbar>
                    <Collapse in={clicked} timeout="auto" unmountOnExit>
                        <Grid sx={{height: "100px"}}>
                            <FormControl variant="outlined"
                                         style={{marginRight: "50px", width: "15%", textAlign: "left"}}>
                                <InputLabel id="serviceFilter">{strings.service}</InputLabel>
                                <Select labelId="serviceFilter"
                                        label={strings.service}
                                        value={serviceIdFilter?.toString() ?? ""}
                                        onChange={handleServiceFilter}
                                        endAdornment={serviceIdFilter && (
                                            <IconButton style={{marginRight: "20px"}}
                                                        onClick={() => setServiceIdFilter(undefined)}
                                            >
                                                <Clear/>
                                            </IconButton>
                                        )}
                                        sx={{
                                            color: "black",
                                            '.MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(112,111,111,0.25)',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'secondary',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'black', borderWidth: "2px"
                                            },
                                            '.MuiSvgIcon-root ': {
                                                fill: "black !important",
                                            }
                                        }}
                                >
                                    {services?.map((filter) => (
                                        <MenuItem disableRipple key={filter.id} value={filter.id}>
                                            {filter.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {countryFilterVisible && <FormControl variant="outlined" style={{marginRight: "50px", width: "15%"}}>
                                <PaginatedSelect<CountryDTO>
                                  value={countryIdFilter}
                                  onChange={handleCountryFilter}
                                  label={strings.country}
                                  valueMapper={(item) => item.id.toString()}
                                  keyMapper={(item) => item.id.toString()}
                                  itemMapper={(item) => <>{item.commonName}</>}
                                  labelMapper={(item) => item.commonName}
                                  dataFetcher={(page, size, filter) => {
                                      if (id) {
                                          return CountryService.findAllCountriesPaged(
                                            page,
                                            size,
                                            filter
                                          );
                                      } else {
                                          return Promise.resolve(new Page<CountryDTO>(
                                            [],
                                            0
                                          ));
                                      }
                                  }}/>
                            </FormControl>}
                        </Grid>
                    </Collapse>
                </AppBar>
                    <Box>
                    <div style={{marginTop: "80px"}}>
                        <Typography
                            style={{fontSize: "3rem"}}><b>{client?.name ? `Welcome, ${client.name}!` : "Welcome!"}</b></Typography>
                        <br/>
                        <Typography style={{
                            fontSize: "1rem",
                        }}>{strings.welcomeAnalytics}<br/>{strings.infoAnalytics}</Typography>

                        {streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS && <Typography style={{
                            fontSize: "1rem",
                            marginTop: "40px",
                        }}>
                            {strings.uniqueListensExplanation}
                        </Typography>
                        }

                        <Box style={{
                            marginBottom: "100px"
                        }}></Box>
                    </div>
                    <div className={"mainDiv"} style={{
                        flexDirection: "row",
                        marginLeft: "40px",
                        width: "77.5%",
                        justifyContent: "space-between",
                        marginBottom: "25px"
                    }}>
                            <div className="div1" style={{display: "flex", flexDirection: "row"}}>
                                <FormControl className="formControl" style={{float: "right", display: "flex", flexDirection: "row"}} variant="outlined" fullWidth>
                                <Typography style={{
                                    marginRight: "20px",
                                    fontSize: "18px",
                                    marginTop: "10px"
                                }}>{strings.view}</Typography>
                                    <Select className="dropdown-menu"
                                            value={`${streamsFilter}`}
                                            onChange={handleStreamsFilter}
                                            style={{
                                                border: "black",
                                                borderStyle: "solid",
                                                borderWidth: "1.5px",
                                                borderRadius: "1px",
                                                backgroundColor: "White"
                                            }}
                                    >
                                        {viewersOptionDropdown?.map((filter) => (
                                            <MenuItem disableRipple key={filter.id} value={filter.id}>
                                                {filter.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="div2" style={{display: "flex", flexDirection: "row"}}>
                                <FormControl className="formControl" variant="outlined" style={{float: "right", display: "flex", flexDirection: "row"}} fullWidth>

                                <Typography style={{
                                    marginRight: "20px",
                                    fontSize: "18px",
                                    marginTop: "10px"
                                }}>{strings.by}</Typography>
                                    <Select value={groupBy} className="dropdown-menu2"
                                            onChange={handleTypeFilter}
                                            style={{
                                                border: "black",
                                                borderStyle: "solid",
                                                borderWidth: "1.5px",
                                                borderRadius: "1px",
                                                backgroundColor: "White"
                                            }}
                                    >
                                        {typeOfFilterOptionDropdown?.map((type) => (
                                            <MenuItem disableRipple key={type.id} value={type.id}>
                                                {type.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="div3" style={{display: "flex", flexDirection: "row"}}>
                                <FormControl className="formControl" variant="outlined" style={{float: "right", display: "flex", flexDirection: "row"}} fullWidth>

                                <Typography style={{
                                    marginRight: "20px",
                                    fontSize: "18px",
                                    marginTop: "10px"
                                }}>{strings.period}</Typography>
                                    <Select className="dropdown-menu3"
                                            value={periodFilter.toString()}
                                            onChange={handlePeriodFilter}
                                            style={{
                                                border: "black",
                                                borderStyle: "solid",
                                                borderWidth: "1.5px",
                                                borderRadius: "1px",
                                                backgroundColor: "White"
                                            }}
                                    >
                                        {periodFilterOptionDropdown?.map((period) => (
                                            <MenuItem disableRipple key={period.id} value={period.id}>
                                                {period.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                        </div>
                        {periodFilter === -1 &&
                            <div className={"mainDiv"} style={{
                                flexDirection: "row",
                                marginLeft: "40px",
                                width: "77.5%",
                                justifyContent: "flex-end",
                                marginBottom: "25px"
                            }}>
                                <div className="div1" style={{display: "flex", flexDirection: "row"}}>

                                    <FormControl className="formControl" variant="outlined"
                                                 style={{float: "right", display: "flex", flexDirection: "row"}}
                                                 fullWidth>
                                        <Typography style={{
                                            marginRight: "20px",
                                            fontSize: "18px",
                                            marginTop: "10px"
                                        }}>{strings.dateFrom}</Typography>
                                        <TextField
                                            type="date"
                                            value={dateFrom}
                                            onChange={handleDateFromChange}
                                            InputLabelProps={{shrink: true}}
                                            style={{
                                                border: "black",
                                                borderStyle: "solid",
                                                borderWidth: "1.5px",
                                                borderRadius: "1px",
                                                backgroundColor: "White"
                                            }}
                                        />
                                    </FormControl>
                                </div>

                                <div className={"div2"}
                                     style={{display: "flex", flexDirection: "row", marginLeft: "20px"}}>
                                    <FormControl className="formControl" variant="outlined"
                                                 style={{float: "right", display: "flex", flexDirection: "row"}}
                                                 fullWidth>
                                        <Typography style={{
                                            marginRight: "20px",
                                            fontSize: "18px",
                                            marginTop: "10px"
                                        }}>{strings.dateTo}</Typography>
                                        <TextField
                                            type="date"
                                            value={dateTo}
                                            onChange={handleDateToChange}
                                            InputLabelProps={{shrink: true}}
                                            style={{
                                                border: "black",
                                                borderStyle: "solid",
                                                borderWidth: "1.5px",
                                                borderRadius: "1px",
                                                backgroundColor: "White"
                                            }}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        }

                        <ChartComponent series={series} views={viewsPerDayGrouped.reduce((views,
                                                                                          groupViews) => views + getStatistic(groupViews.total), 0)}
                                        streamsFilter={streamsFilter}
                                        text={chartText}
                                        categories={getChartCategories()}
                                        tickAmount={tickAmountChange(periodFilter)}
                                        xaxisType="datetime"
                        />
                        {streamsFilter === ViewsCount.STAT_STREAMS && (
                            <Box sx={{ marginTop: "60px", marginBottom: "20px" }}>
                                <ChartComponent
                                    series={aggregateBotPlatformDataByDay()}
                                    views={platformData.reduce((sum, item) => sum + item.mobileViews + item.browserViews, 0)}
                                    streamsFilter={ViewsCount.STAT_STREAMS}
                                    text={artistFilter.length > 0 ? strings.botStreamsByPlatformForArtists : strings.botStreamsByPlatform}
                                    categories={getScrapedDateCategories()}
                                    tickAmount={tickAmountChange(periodFilter)}
                                    xaxisType="datetime"
                                />
                            </Box>
                        )}
                        {/*<ChartComponent series={seriesScraped} views={scrapedViewsPerDayGrouped.reduce((views,*/}
                        {/*    groupViews) => views + getStatistic(groupViews.total), 0)} streamsFilter={streamsFilter}*/}
                        {/*    text={streamsFilter === ViewsCount.STAT_STREAMS ? strings.streamsActual : strings.uniqueListenersActual} categories={getScrapedChartCategories()}*/}
                        {/*    tickAmount={tickAmountChange(periodFilter)}/>*/}

                    </Box>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        {groupBy !== ARTIST && (
                            <div className={"div1"} style={{display: "flex", flexDirection: "row", width: "20%", marginRight: 30}}>
                                <FormControl className="formControl" variant="outlined"
                                             style={{float: "right", display: "flex", flexDirection: "row"}} fullWidth>
                                    <InputLabel>{strings.filter}</InputLabel>
                                    <Select
                                        value={tempFilterValues}
                                        open={open}
                                        onOpen={handleFilterOpen}
                                        onClose={handleFilterClose}
                                        onChange={handleFilterValueChange}
                                        style={{width: "100%", marginBottom: "10px"}}
                                        color={"info"}
                                        multiple
                                        renderValue={(selected) => (
                                            <div>
                                                {(selected as string[]).map(key => {
                                                    const item = sortedDataItems.find(item => item.key === key);
                                                    return item ? item.label : null;
                                                }).join(', ')}
                                            </div>
                                        )}
                                        sx={{
                                            color: "black",
                                            '.MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(112,111,111,0.25)',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'secondary',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'black', borderWidth: "2px"
                                            },
                                            '.MuiSvgIcon-root ': {
                                                fill: "black !important",
                                            },
                                            backgroundColor: "white", borderRadius: 0
                                        }}
                                        endAdornment={
                                            filterValues.length > 0 && (
                                                <IconButton
                                                    onClick={handleRemoveSelectedOptions}
                                                >
                                                    <Clear/>
                                                </IconButton>
                                            )
                                        }
                                        MenuProps={{
                                            disableScrollLock: true,
                                        }}
                                    >
                                        {sortedDataItems.map((item) => (
                                            <MenuItem key={item.key} value={item.key}>
                                                <ListItemText primary={item.label}/>
                                                <Checkbox
                                                    color={"info"}
                                                    checked={tempFilterValues.includes(item.key)}
                                                    onChange={() => {
                                                    }}
                                                />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        )}

                        <Box
                            className="div2"
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                width: { xs: "100%", sm: "60%", md: "40%", lg: "30%" },
                                alignItems: { xs: "stretch", sm: "center" },
                                gap: 2,
                                mb: 2,
                            }}
                        >
                            <FormControl
                                className="formControl"
                                variant="outlined"
                                fullWidth
                                sx={{ flex: 1 }}
                            >
                                <PaginatedMultiSelect<ClientArtistDTO>
                                    value={artistFilter}
                                    onChange={handleArtistFilter}
                                    label={strings.artist}
                                    valueMapper={(item) => item.id.toString()}
                                    keyMapper={(item) => item.id.toString()}
                                    itemMapper={(item) => <>{item.artist}</>}
                                    labelMapper={(item) => item.artist}
                                    dataFetcher={(page, size, filter) => {
                                        if (id) {
                                            return ClientArtistService.finAllArtistsForClientPaged(
                                                page,
                                                size,
                                                id,
                                                filter
                                            );
                                        } else {
                                            return Promise.resolve(new Page<ClientArtistDTO>([], 0));
                                        }
                                    }}
                                    inputProps={{
                                        sx: {
                                            color: "black",
                                            ".MuiOutlinedInput-notchedOutline": {
                                                borderColor: "rgba(112,111,111,0.25)",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "secondary",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "black",
                                                borderWidth: "2px",
                                            },
                                            ".MuiSvgIcon-root ": {
                                                fill: "black !important",
                                            },
                                            backgroundColor: "white",
                                            borderRadius: 0,
                                        },
                                    }}
                                />
                            </FormControl>
                            <Box
                                sx={{
                                    marginLeft: { xs: 0, sm: "25px" },
                                    marginTop: { xs: 2, sm: "5px" },
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: 1,
                                }}
                            >
                                {groupBy === ARTIST && (
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={oursSelected}
                                                    onChange={handleOursCheckboxChange}
                                                    color="primary"
                                                />
                                            }
                                            label={strings.ours}
                                            sx={{ marginRight: 2 }}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={notOursSelected}
                                                    onChange={handleNotOursCheckboxChange}
                                                    color="primary"
                                                />
                                            }
                                            label={strings.notOurs}
                                        />
                                    </>
                                )}
                            </Box>
                        </Box>
                    </div>

                    <TableContainer component={Paper} style={{marginTop: "69px", borderRadius: "10px"}}>
                    <Table>
                        <TableHead>
                            <TableRow></TableRow>
                            <TableRow>
                                <TableCell width={"5%"} onClick={() => requestSort('label')}
                                           style={{fontFamily: "sans-serif", cursor: "pointer"}}>{groupBy === SERVICE ? strings.service : (groupBy === COUNTRY ? strings.country : (groupBy === ARTIST ? strings.artist : ""))}{getSortIcon('label')}</TableCell>
                                <TableCell width={"5%"}></TableCell>
                                <TableCell width={"5%"}></TableCell>
                                {groupBy === ARTIST && (
                                    <>
                                        <TableCell width={"5%"}></TableCell>
                                        <TableCell width={"20%"}>{strings.ours}</TableCell>
                                    </>
                                )}
                                <TableCell width={"20%"} onClick={() => requestSort('botStat')}
                                           style={{fontFamily: "sans-serif", cursor: "pointer"}}>{streamsFilter === ViewsCount.STAT_STREAMS ? strings.streamsBot : streamsFilter === ViewsCount.STAT_ACCOUNTS ? strings.accountsBot : strings.uniqueListenersBot}{getSortIcon('botStat')}</TableCell>
                                {/*<TableCell width={"20%"}*/}
                                {/*           style={{fontFamily: "sans-serif"}}>{streamsFilter === ViewsCount.STAT_STREAMS ? strings.streamsActual : strings.uniqueListenersActual}</TableCell>*/}
                                <TableCell width={"20%"}
                                           style={{fontFamily: "sans-serif", cursor: "pointer"}} onClick={() => requestSort('mobileUniqueListeners')}>{strings.mobileUniqueListeners}{getSortIcon('mobileUniqueListeners')}</TableCell>
                                {streamsFilter === ViewsCount.STAT_STREAMS && (
                                    <>
                                        <TableCell width={"20%"} style={{fontFamily: "sans-serif"}}>{strings.mobileStreams}</TableCell>
                                        <TableCell width={"20%"} style={{fontFamily: "sans-serif"}}>{strings.browserStreams}</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedDataItems.map((dataItem) => (
                                <TableRow key={groupBy + "-" + dataItem.key} hover={true} className="cursor-pointer">
                                    <TableCell style={{fontFamily: "sans-serif"}}>{dataItem.label}</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    {groupBy === ARTIST && (
                                        <>
                                        <TableCell></TableCell>
                                        <TableCell width={"20%"}>
                                            {isOursArtist(dataItem.label) ? <CheckIcon style={{ color: 'green' }} /> : <CloseIcon style={{ color: 'red' }} />}
                                        </TableCell>
                                        </>
                                    )}
                                    <TableCell
                                        style={{fontFamily: "sans-serif"}}>{dataItem.botStat}</TableCell>
                                    {/*<TableCell style={{fontFamily: "sans-serif"}}>{dataItem.scrapedStat}</TableCell>*/}
                                    <TableCell width={"20%"}>{dataItem.mobileUniqueListeners}</TableCell>
                                    {streamsFilter === ViewsCount.STAT_STREAMS && (
                                        <>
                                            <TableCell style={{fontFamily: "sans-serif"}}>{dataItem.mobileViews}</TableCell>
                                            <TableCell style={{fontFamily: "sans-serif"}}>{dataItem.browserViews}</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={groupBy === ARTIST ? 5 : 3} style={{fontFamily: "sans-serif", fontWeight: "bolder", color: "black", fontSize: "0.9rem", padding: "16px"}}>
                                    {strings.total}
                                </TableCell>
                                <TableCell style={{fontFamily: "sans-serif", fontWeight: "bolder", color: "black", fontSize: "0.9rem", padding: "16px"}}>
                                    {totalBotStat}
                                </TableCell>
                                <TableCell style={{fontFamily: "sans-serif", fontWeight: "bolder", color: "black", fontSize: "0.9rem", padding: "16px"}}>
                                    {totalMobileUniqueListeners}
                                </TableCell>
                                {streamsFilter === ViewsCount.STAT_STREAMS && (
                                    <>
                                        <TableCell style={{fontFamily: "sans-serif", fontWeight: "bolder", color: "black", fontSize: "0.9rem", padding: "16px"}}>
                                            {totalMobileStreams}
                                        </TableCell>
                                        <TableCell style={{fontFamily: "sans-serif", fontWeight: "bolder", color: "black", fontSize: "0.9rem", padding: "16px"}}>
                                            {totalBrowserStreams}
                                        </TableCell>
                                    </>
                                )}
                            </TableRow>
                            {groupBy === ARTIST && (
                                <TableRow>
                                    <TableCell colSpan={12} sx={{ borderBottom: 'none', padding: 0 }}>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                            component="div"
                                            count={filteredDataItems.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            sx={{
                                                border: 'none',
                                                '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                                                    fontFamily: 'sans-serif',
                                                },
                                                '.MuiTablePagination-select': {
                                                    fontFamily: 'sans-serif',
                                                },
                                                '.MuiTablePagination-toolbar': {
                                                    justifyContent: 'flex-end',
                                                    paddingRight: '16px',
                                                }
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableFooter>
                    </Table>
                </TableContainer>
                    {groupBy === ARTIST && (
                        <>
                            <Box sx={{ marginTop: "100px" }}>
                                <ChartComponent
                                    series={aggregateScrapedDataByDay()}
                                    views={scrapedDataTotalPerDay.reduce((sum, item) => {
                                        if (streamsFilter === ViewsCount.STAT_STREAMS) {
                                            return sum + (item.viewCount ?? 0);
                                        } else if (streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS) {
                                            return sum + (item.uniqueListeners ?? 0);
                                        }
                                        return sum;
                                    }, 0)}
                                    streamsFilter={streamsFilter}
                                    text={
                                        streamsFilter === ViewsCount.STAT_STREAMS
                                            ? strings.totalStreamsForEveryArtist
                                            : strings.totalUniqueListenersForEveryArtist
                                    }
                                    categories={getScrapedDateCategories()}
                                    tickAmount={tickAmountChange(periodFilter)}
                                    xaxisType="datetime"
                                />
                            </Box>

                            <TableContainer component={Paper} style={{ marginTop: "70px", borderRadius: "10px", marginBottom: "70px" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                onClick={() => handleScrapedSort('artist')}
                                                style={{ fontFamily: "sans-serif", cursor: "pointer", userSelect: "none" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    {strings.artist} {getScrapedSortIcon('artist')}
                                                </div>
                                            </TableCell>
                                            {streamsFilter === ViewsCount.STAT_STREAMS && (
                                                <TableCell
                                                    onClick={() => handleScrapedSort('viewCount')}
                                                    style={{ fontFamily: "sans-serif", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {strings.streamsBot} {getScrapedSortIcon('viewCount')}
                                                    </div>
                                                </TableCell>
                                            )}
                                            {streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS && (
                                                <TableCell
                                                    onClick={() => handleScrapedSort('uniqueListeners')}
                                                    style={{ fontFamily: "sans-serif", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {strings.uniqueListeners} {getScrapedSortIcon('uniqueListeners')}
                                                    </div>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {scrapedDataPaged.map((item: ViewsCountPerDayAndArtistDTO, index: number) => (
                                            <TableRow key={`${item.artist}-${index}`} hover={true}>
                                                <TableCell style={{ fontFamily: "sans-serif" }}>
                                                    {item.artist}
                                                </TableCell>
                                                {streamsFilter === ViewsCount.STAT_STREAMS && (
                                                    <TableCell style={{ fontFamily: "sans-serif" }}>
                                                        {item.viewCount}
                                                    </TableCell>
                                                )}
                                                {streamsFilter === ViewsCount.STAT_UNIQUE_LISTENERS && (
                                                    <TableCell style={{ fontFamily: "sans-serif" }}>
                                                        {item.uniqueListeners}
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end', marginTop: "10px" }}>
                                    <PaginationPlus
                                        totalElements={scrapedTotalElements}
                                        rowsPerPage={scrapedRowsPerPage}
                                        page={scrapedPage}
                                        onChangePage={(page) => handleScrapedChangePage(null, page)}
                                    />
                                    <TablePagination
                                        rowsPerPageOptions={defaultRowsPerPageOptions}
                                        component="div"
                                        count={scrapedTotalElements}
                                        rowsPerPage={scrapedRowsPerPage}
                                        page={scrapedPage}
                                        onPageChange={handleScrapedChangePage}
                                        onRowsPerPageChange={handleScrapedChangeRowsPerPage}
                                    />
                                </Grid>
                            </TableContainer>

                            <Box sx={{ marginTop: "70px" }}>
                                <Typography variant="h5" sx={{ marginBottom: "50px", fontWeight: "bold" }}>
                                    {strings.comparisonTable}
                                </Typography>
                                <TableContainer component={Paper} style={{ borderRadius: "10px", marginBottom: "70px" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    onClick={() => handleComparisonSort('label')}
                                                    style={{ fontFamily: "sans-serif", fontWeight: "bold", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {strings.artist} {getComparisonSortIcon('label')}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    onClick={() => handleComparisonSort('botStat')}
                                                    style={{ fontFamily: "sans-serif", fontWeight: "bold", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {streamsFilter === ViewsCount.STAT_STREAMS ? strings.streamsBot : strings.uniqueListenersBot}
                                                        {getComparisonSortIcon('botStat')}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    onClick={() => handleComparisonSort('scrapedStat')}
                                                    style={{ fontFamily: "sans-serif", fontWeight: "bold", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {streamsFilter === ViewsCount.STAT_STREAMS ? strings.scrapedStreams : strings.scrapedUniqueListens}
                                                        {getComparisonSortIcon('scrapedStat')}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    onClick={() => handleComparisonSort('diff')}
                                                    style={{ fontFamily: "sans-serif", fontWeight: "bold", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {strings.difference} (%)
                                                        {getComparisonSortIcon('diff')}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(() => {
                                                const scrapedByArtist = getScrapedDataByArtist();

                                                const comparisonData = sortedDataItems
                                                    .map((item: DataItem) => {
                                                        const botValue = item.botStat;
                                                        const scrapedValue = scrapedByArtist.get(item.label) || 0;
                                                        const percentageDiff = botValue !== 0 ? ((botValue - scrapedValue) / botValue) * 100 : (scrapedValue !== 0 ? 100 : 0);

                                                        return {
                                                            key: item.key,
                                                            label: item.label,
                                                            botStat: botValue,
                                                            scrapedStat: scrapedValue,
                                                            diff: percentageDiff
                                                        };
                                                    })
                                                    .filter(item => item.botStat > 0 && item.scrapedStat > 0);

                                                const sortedComparisonData = [...comparisonData].sort((a, b) => {
                                                    if (!comparisonSort.key) return 0;

                                                    const aValue = a[comparisonSort.key];
                                                    const bValue = b[comparisonSort.key];

                                                    if (typeof aValue === 'number' && typeof bValue === 'number') {
                                                        return comparisonSort.direction === 'asc' ? aValue - bValue : bValue - aValue;
                                                    }

                                                    return comparisonSort.direction === 'asc'
                                                        ? String(aValue).localeCompare(String(bValue))
                                                        : String(bValue).localeCompare(String(aValue));
                                                });

                                                const paginatedComparisonData = sortedComparisonData.slice(
                                                    comparisonPage * comparisonRowsPerPage,
                                                    comparisonPage * comparisonRowsPerPage + comparisonRowsPerPage
                                                );

                                                return paginatedComparisonData.map((item) => (
                                                    <TableRow key={item.key} hover={true}>
                                                        <TableCell style={{ fontFamily: "sans-serif" }}>
                                                            {item.label}
                                                        </TableCell>
                                                        <TableCell style={{ fontFamily: "sans-serif" }}>
                                                            {item.botStat.toLocaleString()}
                                                        </TableCell>
                                                        <TableCell style={{ fontFamily: "sans-serif" }}>
                                                            {item.scrapedStat.toLocaleString()}
                                                        </TableCell>
                                                        <TableCell style={{
                                                            fontFamily: "sans-serif",
                                                            color: item.diff >= 0 ? 'green' : 'red',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {item.diff.toFixed(2)}%
                                                        </TableCell>
                                                    </TableRow>
                                                ));
                                            })()}
                                        </TableBody>
                                    </Table>
                                    <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end', marginTop: "10px" }}>
                                        {(() => {
                                            const scrapedByArtist = getScrapedDataByArtist();
                                            const filteredCount = sortedDataItems.filter((item: DataItem) => {
                                                const scrapedValue = scrapedByArtist.get(item.label) || 0;
                                                return item.botStat > 0 && scrapedValue > 0;
                                            }).length;

                                            return (
                                                <>
                                                    <PaginationPlus
                                                        totalElements={filteredCount}
                                                        rowsPerPage={comparisonRowsPerPage}
                                                        page={comparisonPage}
                                                        onChangePage={(page) => handleComparisonChangePage(null, page)}
                                                    />
                                                    <TablePagination
                                                        rowsPerPageOptions={defaultRowsPerPageOptions}
                                                        component="div"
                                                        count={filteredCount}
                                                        rowsPerPage={comparisonRowsPerPage}
                                                        page={comparisonPage}
                                                        onPageChange={handleComparisonChangePage}
                                                        onRowsPerPageChange={handleComparisonChangeRowsPerPage}
                                                    />
                                                </>
                                            );
                                        })()}
                                    </Grid>
                                </TableContainer>
                            </Box>
                        </>
                    )}
                </>
            }/>
        </>
    )
}
